import _ from 'lodash';
import convalescenceInfo from './convalescenceInfo';
import convalescenceNotice from './convalescenceNotice';
import convalescenceManagement from './convalescenceManagement';
export default _.union(
  convalescenceInfo,
  convalescenceNotice,
  convalescenceManagement,
  [{
    name: 'convalescenceSystem',
    path: '/convalescenceSystem',
    meta: { title: '疗养预约系统' },
    component: require('views/common/blank.vue').default
  }]
);
